import SubscriptionTag from '@components/membership/subscription-tag/SubscriptionTag'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { SubscriptionTag as SubscriptionTagModel } from '@models/membership/SubscriptionTag'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getSubscriptionTags,
  selectSubscriptionTags,
  setSubscriptionTagQuery,
} from '@store/membership/SubscriptionTagReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { Space } from 'antd'
import { useEffect } from 'react'

const SubscriptionTagsPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const subscriptionTags = useAppSelector(selectSubscriptionTags())
  const { query, isLoading } = useAppSelector((state) => state.subscriptionTag)

  const columns: TableColumnsType<SubscriptionTagModel> = [
    {
      title: 'Tag',
      render: (record: SubscriptionTagModel) => (
        <SubscriptionTag.Tag id={record.id} />
      ),
    },
    {
      align: 'right',
      render: (record: SubscriptionTagModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.subscriptionTag}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchSubscriptionTags = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setSubscriptionTagQuery(newQuery))
    dispatch(getSubscriptionTags(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<SubscriptionTagModel>({
    onParamsChange: fetchSubscriptionTags,
  })

  useEffect(() => {
    if (isOpen) return

    fetchSubscriptionTags(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.manageRequestsMembership}
      pageTitle={{
        title: 'Subscription tags',
        level: 4,
        toolbar: (
          <Space>
            <SBRM.Actions
              actions={[SBRMAction.Create]}
              entity={Entity.subscriptionTag}
            />
          </Space>
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={subscriptionTags}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        showSorterTooltip={{ target: 'sorter-icon' }}
      />
    </Page>
  )
}

export default SubscriptionTagsPage
